$(function(){

  // 「.modal_open」をクリックしたらモーダルと黒い背景を表示する
  $('.modal_preview_open').click(function(){

    // init visibility
    // 設定されているカードを取得する

    let id = $('#card-id').val();
    let from = $('[name="attributes[egift-fromname]"]').val();
    let dear = $('[name="attributes[egift-dearname]"]').val();
    let message = $('[name="attributes[egift-message]"]').val();

    // 値をセットする
    if (dear && dear != "") {
      $('.preview_dear-name').html('<span class="message-label">Dear</span> ' + dear);
    } else {
      $('.preview_dear-name').html("");
    }
    if (from && from != "") {
      $('.preview_from-name').html('<span class="message-label">From</span> ' + from);
    } else {
      $('.preview_from-name').html("");
    }
    $('.preview_message').html(message.replace(/\r?\n/g, '<br>'));

    /* see assets/e-gift-card.js */
    let config = get_card_config(id);

    // set config
    let image_url = config.image;
    let video_url = config.video;
    let joint_url = config.joint;

    let text_color = config.text_color;
    let text_bg_color = config.text_bg_color;

    // set text
    $('.preview_card-text-area').css('color', text_color);
    $('.preview_card-text-area').css('background', text_bg_color);

    // set creative
    if (video_url && video_url != "") {
      let video_html = "";
      video_html = video_html + '<video class="preview_card-video" src="' + video_url + '" poster="' + image_url + '" muted="muted" autoplay="autoplay" loop="loop" playsinline></video>';
      if (joint_url) {
        video_html = video_html + '<div class="preview_card-deco-bar"><img class="preview_card-deco-bar-image" src="' + joint_url + '"></div>';
      }
      $('#card-main-wrapper').html(video_html);

      // loadead
      $('.preview_card-video').on('loadeddata', function() {
        // 読み込み終わったらpreview全体を表示する
        $('.preview_wrapper').addClass('visible');
      });

    } else {
      let image_html = "";
      image_html = image_html + '<img id="card-main-image" class="preview_card-image" src="' + image_url + '">';
      if (joint_url) {
        image_html = image_html + '<div class="preview_card-deco-bar"><img class="preview_card-deco-bar-image" src="' + joint_url + '"></div>';
      }
      $('#card-main-wrapper').html(image_html);

      // image load
      $('.preview_wrapper').addClass('visible');
    }


    // 黒い背景をbody内に追加
    $('body').append('<div class="modal_preview_bg"></div>');
    $('.modal_preview_bg').fadeIn();

    // data-targetの内容をIDにしてmodalに代入
    var modal = '#' + $(this).attr('data-target');

    // モーダルをウィンドウの中央に配置する
    function modalResize(){
        var w = $(window).width();
        var h = $(window).height();

        var x = (w - $(modal).outerWidth(true)) / 2;
        var y = (h - $(modal).outerHeight(true)) / 2;
        y = 50;

        $(modal).css({'left': x + 'px','top': y + '%'});
    }

    // modalResizeを実行
    modalResize();

    // modalをフェードインで表示
    $(modal).fadeIn();

    // .modal_bgか.modal_closeをクリックしたらモーダルと背景をフェードアウトさせる
    $('.modal_preview_bg, .modal_preview_close').off().click(function(){
        $('.modal_preview_box').fadeOut();
        $('.preview_wrapper').removeClass('visible');
        $('.modal_preview_bg').fadeOut('slow',function(){
            $('.modal_preview_bg').remove();
        });
    });

    // ウィンドウがリサイズされたらモーダルの位置を再計算する
    $(window).on('resize', function(){
        modalResize();
    });

    // .modal_switchを押すとモーダルを切り替える
    $('.modal_preview_switch').click(function(){

      // 押された.modal_switchの親要素の.modal_boxをフェードアウトさせる
      $(this).parents('.modal_preview_box').fadeOut();

      // 押された.modal_switchのdata-targetの内容をIDにしてmodalに代入
      var modal = '#' + $(this).attr('data-target');

      // モーダルをウィンドウの中央に配置する
      function modalResize(){
          var w = $(window).width();
          var h = $(window).height();

          var x = (w - $(modal).outerWidth(true)) / 2;
          var y = (h - $(modal).outerHeight(true)) / 2;
          y = 50;

          $(modal).css({'left': x + 'px','top': y + '%'});
      }

      // modalResizeを実行
      modalResize();

      $(modal).fadeIn();

      // ウィンドウがリサイズされたらモーダルの位置を再計算する
      $(window).on('resize', function(){
          modalResize();
      });
    });
  });
});
